import {Injectable} from '@angular/core';
import {RadioCheckBoxEnum} from '../../../../common/radio.checkbox.enums';
import {Oui_TypeOuiNonNbCandidatReduitFNSSimple} from '../../models/Oui_TypeOuiNonNbCandidatReduitFNSSimple';
import {PresOffresFNS} from '../../models/PresOffresFNS';
import {TechAchatFNS} from '../../models/TechAchatFNS';
import {TypeOuiNon} from '../../models/TypeOuiNon';
import {TypeOuiNonNbCandidatReduitFNSSimple} from '../../models/TypeOuiNonNbCandidatReduitFNSSimple';
import {TypeProcFNS} from '../../models/TypeProcFNS';
import {SimpINControlNames} from '../../simpINControleNames';

@Injectable({
  providedIn: 'root',
})
export class ProcedureService {
  constructor() {
  }

  getProcedure(controls): TypeProcFNS {
    const procedure = new TypeProcFNS();
    procedure.capaciteExercice = controls.get(SimpINControlNames.capaciteExercice);
    procedure.capaciteEcoFin = controls.get(SimpINControlNames.capaciteEcoFin);
    procedure.capaciteTech = controls.get(SimpINControlNames.capaciteTech);
    procedure.categorieAcheteur = controls.get(SimpINControlNames.categorieAcheteur);
    procedure.procedureAdapteeR = controls.get('_SepSep_Initial_SepSep_TypeProcFNS_SepAtt_procedureAdapteeO') === RadioCheckBoxEnum.procedureAdapteeRValue ? RadioCheckBoxEnum.emptyValue : null;
    procedure.procedureAdapteeO = controls.get('_SepSep_Initial_SepSep_TypeProcFNS_SepAtt_procedureAdapteeO') === RadioCheckBoxEnum.procedureAdapteeOValue ? RadioCheckBoxEnum.emptyValue : null;

    const dateReceptionOffres = SimpINControlNames.dateReceptionOffres;
    procedure.dateReceptionOffres =
      controls.get(dateReceptionOffres)
    // + controls.get(dateReceptionOffres + '_timestamp');

    procedure.criteresAttrib = controls.get(SimpINControlNames.criteresAttrib);

    procedure.presOffres = new PresOffresFNS();
    procedure.presOffres.exigee = controls.get('_SepSep_Initial_SepSep_TypeProcFNS_SepSep_PresOffresFNS_SepAtt_exigee') === RadioCheckBoxEnum.exigeeValue ? RadioCheckBoxEnum.emptyValue : null;
    procedure.presOffres.autorisee = controls.get('_SepSep_Initial_SepSep_TypeProcFNS_SepSep_PresOffresFNS_SepAtt_exigee') === RadioCheckBoxEnum.autoriseeValue ? RadioCheckBoxEnum.emptyValue : null;
    procedure.presOffres.interdite = controls.get('_SepSep_Initial_SepSep_TypeProcFNS_SepSep_PresOffresFNS_SepAtt_exigee') === RadioCheckBoxEnum.interditeValue ? RadioCheckBoxEnum.emptyValue : null;

    procedure.techAchat = new TechAchatFNS();
    procedure.techAchat.sysQuali = controls.get(SimpINControlNames.accordCadre) === RadioCheckBoxEnum.sysQualiValue ? RadioCheckBoxEnum.emptyValue : null;
    procedure.techAchat.sad = controls.get(SimpINControlNames.accordCadre) === RadioCheckBoxEnum.sadValue ? RadioCheckBoxEnum.emptyValue : null;
    procedure.techAchat.concours = controls.get(SimpINControlNames.accordCadre) === RadioCheckBoxEnum.concoursValue ? RadioCheckBoxEnum.emptyValue : null;
    procedure.techAchat.autres = controls.get(SimpINControlNames.accordCadre) === RadioCheckBoxEnum.autresValue ? RadioCheckBoxEnum.emptyValue : null;
    procedure.techAchat.accordCadre = controls.get(SimpINControlNames.accordCadre) === RadioCheckBoxEnum.accordCadreValue ? RadioCheckBoxEnum.emptyValue : null;
    procedure.techAchat.enchereElec = controls.get(SimpINControlNames.accordCadre) === RadioCheckBoxEnum.enchereElecValue ? RadioCheckBoxEnum.emptyValue : null;
    procedure.techAchat.catalogueElec = controls.get(SimpINControlNames.accordCadre) === RadioCheckBoxEnum.catalogueElecValue ? RadioCheckBoxEnum.emptyValue : null;

    procedure.nbCandidatReduit = new TypeOuiNonNbCandidatReduitFNSSimple();
    if (controls.get('_SepSep_Initial_SepSep_TypeProcFNS_SepSep_TypeOuiNonNbCandidatReduitFNSSimple_SepAtt_non') === 'Oui') {
      procedure.nbCandidatReduit.non = null;
      procedure.nbCandidatReduit.oui = new Oui_TypeOuiNonNbCandidatReduitFNSSimple();
      procedure.nbCandidatReduit.oui.nbCandidat = controls.get('_SepSep_Initial_SepSep_TypeProcFNS_SepSep_TypeOuiNonNbCandidatReduitFNSSimple_SepSep_Oui_TypeOuiNonNbCandidatReduitFNSSimple_SepAtt_nbCandidat');
      procedure.nbCandidatReduit.oui.criteres = controls.get('_SepSep_Initial_SepSep_TypeProcFNS_SepSep_TypeOuiNonNbCandidatReduitFNSSimple_SepSep_Oui_TypeOuiNonNbCandidatReduitFNSSimple_SepAtt_criteres');
    } else if (controls.get('_SepSep_Initial_SepSep_TypeProcFNS_SepSep_TypeOuiNonNbCandidatReduitFNSSimple_SepAtt_non') === 'Non') {
      procedure.nbCandidatReduit.oui = null;
      procedure.nbCandidatReduit.non = RadioCheckBoxEnum.emptyValue;
    } else {
      procedure.nbCandidatReduit.oui = null;
      procedure.nbCandidatReduit.non = null;
    }

    procedure.attributionSansNegociation = new TypeOuiNon();
    if (controls.get('_SepSep_Initial_SepSep_TypeProcFNS_SepSep_attributionSansNegociation_SepSep_TypeOuiNon_SepAtt_oui') === 'Oui') {
      procedure.attributionSansNegociation.oui = true;
      procedure.attributionSansNegociation.non = null;
    } else if (controls.get('_SepSep_Initial_SepSep_TypeProcFNS_SepSep_attributionSansNegociation_SepSep_TypeOuiNon_SepAtt_oui') === 'Non') {
      procedure.attributionSansNegociation.oui = null;
      procedure.attributionSansNegociation.non = true;
    } else {
      procedure.attributionSansNegociation.oui = null;
      procedure.attributionSansNegociation.non = null;
    }

    procedure.variantes = new TypeOuiNon();
    if (controls.get('_SepSep_Initial_SepSep_TypeProcFNS_SepSep_variantes_SepSep_TypeOuiNon_SepAtt_oui') === 'Oui') {
      procedure.variantes.oui = true;
      procedure.variantes.non = null;
    } else if (controls.get('_SepSep_Initial_SepSep_TypeProcFNS_SepSep_variantes_SepSep_TypeOuiNon_SepAtt_oui') === 'Non') {
      procedure.variantes.oui = null;
      procedure.variantes.non = true;
    } else {
      procedure.variantes.oui = null;
      procedure.variantes.non = null;
    }

    return procedure;
  }
}
